import { OperationExposureModel } from '../../../api/api';

export type OperationExposureChannel = 'api' | 'mcp';

export const participatesInMcp = (exposure: OperationExposureModel): boolean =>
	exposure === OperationExposureModel.ApiAndMcp || exposure === OperationExposureModel.McpOnly;

export const participatesInApi = (exposure: OperationExposureModel): boolean =>
	exposure === OperationExposureModel.ApiAndMcp || exposure === OperationExposureModel.Api;

export const exposureToChannels = (exposure: OperationExposureModel): OperationExposureChannel[] => {
	switch (exposure) {
		case OperationExposureModel.ApiAndMcp:
			return ['api', 'mcp'];
		case OperationExposureModel.McpOnly:
			return ['mcp'];
		case OperationExposureModel.Api:
		default:
			return ['api'];
	}
};

export const channelsToExposure = (channels: OperationExposureChannel[]): OperationExposureModel => {
	const hasApi = channels.includes('api');
	const hasMcp = channels.includes('mcp');

	if (hasApi && hasMcp) {
		return OperationExposureModel.ApiAndMcp;
	}

	if (hasMcp) {
		return OperationExposureModel.McpOnly;
	}

	return OperationExposureModel.Api;
};
